import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';

const testimonials = [
  {
    text: "Hamo Tech has completely reshaped my approach to tech development. The mentorship and resources provided were unparalleled, allowing me to advance my career significantly.",
    name: "Ava Simmons",
    title: "Software Engineer, Google",
    profiles: [
      'https://educrat-react.vercel.app/assets/img/home-3/testimonials/1.png',
      'https://educrat-react.vercel.app/assets/img/home-3/testimonials/2.png',
      'https://educrat-react.vercel.app/assets/img/home-3/testimonials/3.png',
      'https://educrat-react.vercel.app/assets/img/home-3/testimonials/4.png',
      'https://educrat-react.vercel.app/assets/img/home-3/testimonials/5.png',
    ]
  },
  {
    text: "The courses I attended at Hamo Tech provided me with critical skills that I use every day in my role as a data scientist. I feel empowered to take on more complex challenges now.",
    name: "Liam Davis",
    title: "Data Scientist, Facebook",
    profiles: [
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/1.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/2.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/3.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/4.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/5.png',
      ]
  },
  {
    text: "I came to Hamo Tech hoping to broaden my coding knowledge, and I walked away with a new perspective on problem-solving and tech leadership.",
    name: "Noah Martinez",
    title: "Tech Lead, Amazon",
    profiles: [
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/1.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/2.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/3.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/4.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/5.png',
      ]
  },
  {
    text: "Hamo Tech not only provided me with solid technical knowledge but also taught me how to navigate the fast-paced world of software development effectively.",
    name: "Ethan Brown",
    title: "Full Stack Developer, Microsoft",
    profiles: [
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/1.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/2.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/3.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/4.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/5.png',
      ]
  },
  {
    text: "The insights gained from the leadership programs at Hamo Tech transformed my career trajectory. I now approach problems with more confidence and efficiency.",
    name: "Sophia Johnson",
    title: "UX/UI Designer, Apple Inc",
    profiles: [
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/1.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/2.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/3.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/4.png',
        'https://educrat-react.vercel.app/assets/img/home-3/testimonials/5.png',
      ]
  }
];

const TestimonialSlider = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleProfileClick = (profileIdx) => {
    setIndex(profileIdx); // Slide the carousel to the selected profile's index
  };

  return (
    <div>
      <Carousel activeIndex={index} onSelect={handleSelect} interval={3000} indicators={false}>
        {testimonials.map((testimonial, idx) => (
          <Carousel.Item key={idx}>
            <div className="d-flex flex-column align-items-center">
                <div className='testimonials__icon mb-2'><img src='https://educrat-react.vercel.app/assets/img/misc/quote.svg' alt="testimonial"/></div>
              <blockquote className="blockquote text-center">
                <p className="mb-0 testimonials__text about_testimonials__text md:text-20 fw-500 text-dark-1">{testimonial.text}</p>
                <footer className="blockquote-footer text-17 lh-15 fw-500">
                  {testimonial.name} <cite title="Source Title">{testimonial.title}</cite>
                </footer>
              </blockquote>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Fixed profile images section */}
      <div className="d-flex justify-content-center mt-3">
        {testimonials[index].profiles.map((profile, profileIdx) => (
          <img
            key={profileIdx}
            src={profile}
            alt={`Profile ${profileIdx + 1}`}
            className={`rounded-circle mx-2 ${index === profileIdx ? 'border border-primary' : ''}`}
            style={{ width: '50px', height: '50px', cursor: 'pointer' }}
            onClick={() => handleProfileClick(profileIdx)}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialSlider;
